import {ENDPOINT_URL, UNAUTHORIZED, WRONGKEY} from 'constants/index';
const headers = new Headers();
headers.append('Content-Type', 'application/json');

export default function sendPin(testUser) {
	return fetch(`${ENDPOINT_URL}/sendpintouser`, {
		method: 'POST',
		mode: 'cors',
		credentials: 'include',
		headers,
		body: JSON.stringify(testUser),
	})
		.then((response) => {
			if (response.ok) {
				return response.json();
			}
			let errorMessage;
			if (response.status === 500) {
				errorMessage = 'Ikke gyldig testKode ';
				return Promise.reject(errorMessage);
			}

			return Promise.reject(response);
		})
		.catch((error) => {
			console.log('error', error);
		});
}
